export default __webpack_public_path__ + "static/media/151-radiators.f34bcbe8.png";